import { getDomainTracking, saveLocalStorage } from 'configs/localStorage';
import emptySplitApi from '..';

// Define a service using a base URL and expected endpoints

const domainTrackingApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    domainTracking: build.query({
      query: () => ({
        url: '/domain-tracking',
        method: 'GET',
        params: { domainName: document.location.origin || 'http://localhost:3000' },
      }),
      transformResponse: (response) => {
        const { key } = getDomainTracking();
        const data = response.length === 0 ? {} : response[0];
        if (!key || key !== data.key) {
          saveLocalStorage({ domainTracking: data });
        }
        return data;
      },
      providesTags: ['domain-tracking'],
    }),
  }),

  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const { useDomainTrackingQuery, useLazyDomainTrackingQuery } = domainTrackingApi;
export default domainTrackingApi;
